import { InputAmount } from '@vrplatform/components';
import { Input as MantineInput } from '@mantine/core';
import { Controller, useFormContext } from 'react-hook-form';
import type { FormInputBaseType } from './_base-input-types';

type Props = FormInputBaseType;

export const NumberInput = ({
  label,
  formKey,
  defaultValue = '',
  required = true,
  disabled,
  placeholder,
  onValueChange,
}: Props) => {
  const { control } = useFormContext();

  return (
    <MantineInput.Wrapper label={label}>
      <Controller
        control={control}
        name={formKey}
        defaultValue={defaultValue}
        rules={{ required: required }}
        render={({ field: { onChange, value } }) => (
          <InputAmount
            placeholder={placeholder || label || ''}
            value={Number(value)}
            setValue={(value) => {
              onValueChange?.(formKey, value.toString());
              onChange(value);
            }}
            name={formKey}
            disabled={disabled}
            sx={{ input: { borderColor: '#CED0D780' } }}
          />
        )}
      />
    </MantineInput.Wrapper>
  );
};
